// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag[data-v-77d17b34]{font-size:1rem;display:flex;justify-content:center;align-items:center;padding:0 7px;border-radius:40px;font-weight:bold;transition:all .2s;cursor:pointer}.tag[data-v-77d17b34]:hover{box-shadow:0 3px 10px 0 #cdcdcd;background:rgba(0,0,0,0)}.tag .close[data-v-77d17b34]{font-size:1rem;z-index:10}.tag .close[data-v-77d17b34]:hover{opacity:1}", ""]);
// Exports
module.exports = exports;
